/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Type for button component sub types.
 */
export enum WhatsAppTemplateMessageButtonSubType {
    QUICK_REPLY = 'quick_reply',
    URL = 'url',
    PHONE_NUMBER = 'phone_number',
}
